/*
 * @Description:  http 配置
 * @Author: knx-xc
 * @LastEditTime: 2020-09-11 11:20:40
 * @LastEditors: knx-xc
 */


import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import router from '../router'

import { Message } from "element-ui"
Vue.prototype.$message = Message


import { clearLoginInfo} from '../tools/index'


Vue.prototype.$url = process.env.VUE_APP_API_URL;
Vue.prototype.$uploadURL = process.env.VUE_APP_API_URL + '/manage/common/upload';
Vue.prototype.$getToken = () => {
  return { 'token': Vue.cookie.get('token') }
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

axios.interceptors.request.use(
  config => {
    config.baseURL = process.env.VUE_APP_API_URL;
    config.headers['token'] = Vue.cookie.get('token');
    if (config.formData) {
      config.transformRequest = [function (data) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded;multipart/form-data; charset=utf-8';
        let ret = "";
        for (let it in data) {
          ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      }];
    } else {
      config.headers['Content-Type'] = 'application/json; charset=utf-8';
      config.transformRequest = [function (data) {
        return JSON.stringify(data);
      }]
    }
    return config
  },
  err => {
    return Promise.reject(err);
  }
)


const http = (options) => {
  // console.log(options)
  let _params = {
    url: options.api,
    method: !options.method ? 'post' : options.method.toLowerCase(),
    formData: options.formData || false,
    stream: options.stream || false
  }
  if (_params.method == 'get') {
    _params.params = options.data;
  } else {
    _params.data = options.data;
  }
  return new Promise((resolve, reject) => {
    axios(_params).then((res) => {
      // console.log(res)
      let data = res.data;
      if (_params.stream) {
        resolve(data)
        return
      }
      if (data.code === 401) {
        clearLoginInfo();
        // router.push({ name: 'login' })
        router.replace({ name: 'login' })
      } else if (data.code === 0) {
        resolve(data)
      } else {
        // Message({
        //   message: data.msg,
        //   type: 'error'
        // });
        Message.error(data.msg)
        resolve(data)
      }
      // if (response.status == 200) {
      //   if (response.data && response.data.code === 401) {
      //     router.push({ name: 'login' })
      //   } else if (response.data && response.data.code === 0) {
      //     return response.data;
      //   } else if (response.data && response.data.code === -1) {
      //     Message({
      //       message: response.data.msg,
      //       type: 'error'
      //     });
      //   } else if (response.data && response.data.code === 500) {
      //     Message({
      //       message: response.data.msg,
      //       type: 'error'
      //     });
      //     // return response.data;
      //   } else {

      //   }
      // }
    }).catch(err => {
      reject(err)
    })
  })
}

axios.interceptors.response.use(function (response) {
  // console.log(response)
  if (response.status == 200) {
    return response;
  }
}, function (error) {
  return Promise.reject(error);
});

Vue.prototype.$http = http;
Vue.prototype.$axios = axios;

export default http